import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ErrorBoundary from "./ErrorBoundary";
import { NavigationProvider } from "@context/navigation-provider";
import { store } from "@store/index";
import { adoptGuestFromUrl } from "@services/guest";
import "@scss/common/base.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import 'react-international-phone/style.css';

adoptGuestFromUrl();


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
/* -------------------------------------------------------------------------- */
/*                               UseState Section                             */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/*                               React Query Section                          */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/*                               API Section                                  */
/* -------------------------------------------------------------------------- */
/* -------------------------------------------------------------------------- */
/*                               Onchange section                             */
/* -------------------------------------------------------------------------- */

root.render(
  <Provider store={store}>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1c1917",
          colorInfo: "#1c1917",
          colorText: "#1c1917",
          colorTextSecondary: "#6b6560",
          colorBorder: "#e7e1d8",
          colorBgLayout: "#f3f1ee",
          borderRadius: 8,
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
          controlHeight: 32,
          controlHeightLG: 36,
        },
        components: {
          Button: { fontWeight: 600, primaryShadow: "none", controlHeight: 32, paddingInline: 14 },
          Layout: { headerHeight: 52, headerPadding: "0 12px" },
          Table: { headerBg: "#faf8f6", headerColor: "#44403c", cellPaddingBlock: 10 },
          Input: { controlHeight: 32, activeShadow: "0 0 0 3px rgba(28,25,23,0.08)" },
        },
      }}
    >
    <NavigationProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </NavigationProvider>
    </ConfigProvider>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
